export const NODE_ENVIRONMENTS = {
  LOCAL: 'LOCAL',
  DEVELOPMENT: 'DEVELOPMENT',
  STAGING: 'TEST',
  PRODUCTION: 'PRODUCTION'
};

export const TRP_ENVIRONMENTS = {
  DEVELOPMENT: 'DEV',
  STAGING: 'STAGE',
  PRODUCTION: 'PROD',
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL'
};

export const APIGEE_ENVIRONMENTS = {
  DEVELOPMENT: 'DEV',
  STAGING: 'CONFIDENCE',
  PRODUCTION: 'PUBLIC'
};

export const projectName = 'accountaccess';

export const isSandbox = () => {
  return getENV() === NODE_ENVIRONMENTS.LOCAL;
};

export const getENV = () => {
  if (
    deriveEnvironment(getBaseUrl()) === NODE_ENVIRONMENTS.LOCAL ||
    // eslint-disable-next-line no-undef
    (process.env.TRP_AWS_ENVIRONMENT === undefined &&
      // eslint-disable-next-line no-undef
      process.env.NODE_ENV &&
      // eslint-disable-next-line no-undef
      process.env.NODE_ENV.toUpperCase() === NODE_ENVIRONMENTS.DEVELOPMENT)
  ) {
    return NODE_ENVIRONMENTS.LOCAL;
  }
  if (
    deriveEnvironment(getBaseUrl()) === TRP_ENVIRONMENTS.DEVELOPMENT ||
    // eslint-disable-next-line no-undef
    (process.env.TRP_AWS_ENVIRONMENT &&
      // eslint-disable-next-line no-undef
      process.env.TRP_AWS_ENVIRONMENT.toUpperCase() ===
        TRP_ENVIRONMENTS.DEVELOPMENT &&
      // eslint-disable-next-line no-undef
      process.env.NODE_ENV.toUpperCase() === NODE_ENVIRONMENTS.DEVELOPMENT)
  ) {
    return TRP_ENVIRONMENTS.DEVELOPMENT;
  }
  if (
    deriveEnvironment(getBaseUrl()) === TRP_ENVIRONMENTS.STAGING ||
    // eslint-disable-next-line no-undef
    (process.env.TRP_AWS_ENVIRONMENT &&
      // eslint-disable-next-line no-undef
      process.env.TRP_AWS_ENVIRONMENT.toUpperCase() ===
        TRP_ENVIRONMENTS.STAGING &&
      // eslint-disable-next-line no-undef
      process.env.NODE_ENV &&
      // eslint-disable-next-line no-undef
      process.env.NODE_ENV.toUpperCase() === NODE_ENVIRONMENTS.DEVELOPMENT)
  ) {
    return TRP_ENVIRONMENTS.STAGING;
  }
  return TRP_ENVIRONMENTS.PRODUCTION;
};

export const getEnvironmentAwareBaseURL = () =>
  isInternalContext(getBaseUrl())
    ? GLOBALS.AAM_UI_INTERNAL_BASE_URL
    : GLOBALS.AAM_UI_EXTERNAL_BASE_URL;

export const getEnvironmentPrefix = (
  ENV,
  includeDot = true,
  dropPrefix = false,
  hideDotNonProd = true
) => {
  return ENV === TRP_ENVIRONMENTS.LOCAL || ENV === TRP_ENVIRONMENTS.DEVELOPMENT
    ? `${includeDot ? '.' : ''}${TRP_ENVIRONMENTS.DEVELOPMENT.toLowerCase()}`
    : ENV === TRP_ENVIRONMENTS.STAGING
    ? `${includeDot ? '.' : ''}${TRP_ENVIRONMENTS.STAGING.toLowerCase()}`
    : ENV === TRP_ENVIRONMENTS.PRODUCTION && hideDotNonProd
    ? `${includeDot ? '.' : ''}${
        dropPrefix ? '' : TRP_ENVIRONMENTS.PRODUCTION.toLowerCase()
      }`
    : '';
};

const getApigeeEnvironmentPrefix = (ENV, includeDot = true) => {
  if (isInternalContext(getBaseUrl())) {
    return ENV === TRP_ENVIRONMENTS.LOCAL ||
      ENV === TRP_ENVIRONMENTS.DEVELOPMENT
      ? `${includeDot ? '.' : ''}${TRP_ENVIRONMENTS.DEVELOPMENT.toLowerCase()}`
      : ENV === TRP_ENVIRONMENTS.STAGING
      ? `${includeDot ? '.' : ''}${TRP_ENVIRONMENTS.STAGING.toLowerCase()}`
      : ENV === TRP_ENVIRONMENTS.PRODUCTION
      ? `${includeDot ? '.' : ''}${TRP_ENVIRONMENTS.PRODUCTION.toLowerCase()}`
      : '';
  }

  return ENV === TRP_ENVIRONMENTS.LOCAL || ENV === TRP_ENVIRONMENTS.DEVELOPMENT
    ? `${includeDot ? '.' : ''}${APIGEE_ENVIRONMENTS.DEVELOPMENT.toLowerCase()}`
    : ENV === TRP_ENVIRONMENTS.STAGING
    ? `${includeDot ? '.' : ''}${APIGEE_ENVIRONMENTS.STAGING.toLowerCase()}`
    : ENV === TRP_ENVIRONMENTS.PRODUCTION
    ? `${includeDot ? '.' : ''}${APIGEE_ENVIRONMENTS.PRODUCTION.toLowerCase()}`
    : '';
};

export const FEATURES = {
  AAM_UI_BUSINESS_EVENT_DISPATCH: true,
  AAM_UI_ENABLE_CACHE: true,
  AAM_UI_FEATURE_AS_COMMENTARY: true,
  AAM_UI_FEATURE_PGT_COMMENTARY: true,
  AAM_UI_FEATURE_PRR_COMMENTARY: true,
  AAM_UI_FEATURE_SERVER_DOWN: false,
  AAM_UI_INTERNAL_ACCOUNT_DETAILS_PAGE: true,
  AAM_UI_INTERNAL_CMM: true,
  AAM_UI_INTERNAL_MESSAGE_CENTER_PAGE: true,
  AAM_UI_NEW_PASSWORD_LINK: true,
  AAM_UI_NEW_USERNAME_LINK: true,
  AAM_UI_INTRADAY_REFRESH: true,
  AAM_UI_NET_X_LOGOUT_URL: true,
  AAM_UI_T_ROWE_REPORT_ENABLED: false,
  NEW_RELIC_ENABLED: true,
  AAM_UI_ENHANCED_BENEFITS_PAGE: true,
  AAM_UI_PERSONAL_BENEFITS_PAGE: true,
  AAM_UI_CORE_BENEFITS_PAGE: true,
  AAM_UI_TAX_SUMMARY_CARD: true,
  AAM_UI_GRANT_VIEW_ACCESS_PAGE: true,
  AAM_UI_GVA_ADD_NEW_BUTTON: true,
  AAM_UI_IRA_CONTRIBUTION_CARD: true,
  AAM_UI_FINANCIAL_PLANNING_LINK: true,
  AAM_UI_NEW_MESSAGE_CENTER_COUNT: true,
  AAM_UI_WALL_STREET_JOURNAL: true,
  AAM_UI_ACCOUNT_REGISTRATION: true,
  AAM_UI_CUSTOM_VIDEO_ENABLED: true,
  AAM_UI_MULTIFACTOR_SECURTIY_LINK: true,
  AAM_UI_ALERTS_AND_NOTIFICATIONS: true,
  AAM_UI_RAS_PERFORMANCE_PAGE: true,
  AAM_UI_RPS_YTD_ENABLED: true,
  AAM_UI_OLD_BENEFITS: false,
  AAM_UI_RAS_WITHDRAW_LINKS: true,
  AAM_UI_DASHBOARD_CTA_BUTTONS_ENABLED: true,
  AAM_UI_UPDATED_SUMMIT_BENEFITS_ENABLED: true,
  AAM_UI_GLOBAL_PREFERENCES_SUBSCRIPTIONS_ENABLED: true,
  AAM_UI_UPDATED_LIFE_EVENTS_ENABLED: true,
  AAM_UI_DOCUMENT_ACCOUNT_SHELL_ENABLED: true,
  AAM_UI_MARGIN_JOURNAL_ENABLED: false,
  AAM_UI_RMD_DIRECT: true,
  AAM_UI_MD_MATCH_CWV_ENABLED: true,
  AAM_UI_RMD_GAUGE_CARD: true,
  NASU_INPROGRESS_RETURN_JOURNEY_TILE: true,
  AAM_UI_OWNED_529_ONLY_BRANDING: true,
  AAM_UI_BENEFICIARY_LOCK_DISABLE: false,
  II_COMPONENTS_FOOTER_ENABLED: true,
  AAM_SHARE_CLASS_CONVERSION_ENABLED: true,
  AAM_SHARE_CLASS_CONVERSION_TABLE_ENABLED: true,
  AAM_UI_RESIDENTIAL_ADDRESS_ENABLED: true,
  AAM_UI_PAPERLESS_PAGE_ENABLED: true,
  AAM_UI_ROTH_INHERITED_ACCOUNTS_GVA_ENABLED: true,
  AAM_UI_NON_529_ONLY_LEGAL_REFERENCE_NUMBER_ENABLE: true,
  AAM_UI_CLIENT_MISSIONS_ENABLED: true,
  AAM_UI_LEGAL_REFERENCE_NUMBER_ENABLE: true,
  AAM_UI_LOADING_BAR: false,
  AAM_UI_BANKING_PAGE_UPDATE_ACCOUNT_FORMS: true,
  AAM_UI_PRINT_DOM_LAYOUT_ENABLED: true,
  AAM_UI_BROKERAGE_I_FRAME_ENABLED: true,
  AAM_UI_PORTFOLIO_GROWTH_CHART_SHARE_CLASS: true,
  AAM_UI_EDUCATION_PLANNING_CENTER_DISABLED: true,
  AAM_UI_RETAIL_TRAC_ENABLED: true,
  AAM_UI_PORTFOLIO_GROWTH_CHART_ERROR_SCREEN_ENABLED: false,
  AAM_UI_ACTIVITY_SUMMARY_ERROR_SCREEN_ENABLED: false,
  AAM_UI_BEACON_DATE_SELECTOR_ENABLED: true,
  AAM_UI_ACCOUNTS_GRID_BEACON_DATE_SELECTOR_ENABLED: true,
  AAM_UI_ACTIVITY_PAGE_BEACON_DATE_SELECTOR_ENABLED: true,
  AAM_UI_STATEMENT_PAGE_NO_TAX_DOCUMENT_TEXT_UPDATE_ENABLED: true,
  AAM_UI_DIVCAPGAINS_INCLUDE_NEW_RETIREMENT_FUNDS: true,
  AAM_UI_CUSTODY_STATEMENT_ENABLED: true,
  AAM_UI_RAS_POA: true,
  AAM_UI_TRUSTED_CONTACTS_ACCOUNT_NUMBER_ENABLED: true,
  AAM_UI_AK_529_DECOM_ENABLED: true,
  AAM_UI_MANAGE_PASSKEY_ENABLED: true,
  AAM_UI_ADDRESS_ON_FILE_BUTTON_ENABLED: true,
  AAM_UI_DELETE_BANK_NEW_API: false,
  AAM_UI_GVA_NEW_COPY_ENABLED: true,
  CLIENT_PORTAL_ENABLED: true,
  REDIRECT_TO_CLIENT_PORTAL_ENABLED: true,
  AAM_UI_MONEY_MARKET_CUTOFF_ENABLED: true,
  AAM_UI_BENEFICIARIES_V2: true,
  AAM_UI_UPDATED_NOVEMBER_BENCHMARKS_ENABLED: true,
  AAM_UI_BENEFICIARIES_V2_JOINT_TO_TOD: false,
  AAM_UI_PERFORMANCE_PAGE_LABELS: true,

  //Start Brokerage Feature Flags
  AAM_UI_BROKERAGE_ORDER_STATUS_TABLES: false,
  AAM_UI_BROKERAGE_TRADING: false,
  AAM_UI_BROKERAGE_INTERCEPT_MESSAGE: true,
  AAM_UI_BROKERAGE_ACCOUNT_DASHBOARD_MESSAGE: true,
  AAM_UI_BALANCE_DETAILS_ENABLED: false,
  AAM_UI_ENABLE_BRK_ADVANTAGE_BENE: true,
  //END Brokerage Feature Flags
  // Set AAM_UI_CONTACT_METHOD_ANNUAL_VERIFICATION to false will turn off CMM annual review
  AAM_UI_CONTACT_METHOD_ANNUAL_VERIFICATION: false,
  AAM_UI_ENABLE_INHERITED_BENE_DECEASED:true,
  AAM_UI_INTRADAY_PAGE_LOAD: false,
  AAM_UI_FRONTEND_MONITORING_ENABLED: true
};

export const getSearchParams = (search) => {
  const params = {};
  const paramStrings = search.split('&');
  const cleanParamStrings = paramStrings.map((str) => str.replace('?', ''));
  const queryPairs = cleanParamStrings.map((paramStr) => paramStr.split('='));
  queryPairs.forEach((pair) => (params[pair[0]] = pair[1]));
  return params;
};

export const getUrlParts = () => {
  if (!window && !window.location) {
    return;
  }
  const hostName = window.location.hostname;
  const port = window.location.port;
  const protocol = window.location.protocol;
  const relativePath = window.location.pathname;
  return {
    hostName,
    port,
    protocol,
    relativePath
  };
};

export const getBaseUrl = () => {
  const urlParts = getUrlParts();
  const { hostName, port, protocol } = urlParts;
  if (port) {
    return `${protocol}//${hostName}:${port}`;
  }
  return `${protocol}//${hostName}`;
};

export const getRelativePath = () => {
  const urlParts = getUrlParts();
  const { relativePath } = urlParts;
  return `${relativePath}`;
};

export const getFullUrl = () => {
  const basePath = getBaseUrl();
  const relativePath = getRelativePath();
  return `${basePath}${relativePath}`;
};

export const deriveEnvironment = (baseUrl) => {
  if (baseUrl && baseUrl.indexOf('localhost:') !== -1) {
    return TRP_ENVIRONMENTS.DEVELOPMENT;
  }
  if (baseUrl && baseUrl.indexOf('localhost.troweprice.com:') !== -1) {
    return TRP_ENVIRONMENTS.DEVELOPMENT;
  }
  if (baseUrl && baseUrl.indexOf('dev.') !== -1) {
    return TRP_ENVIRONMENTS.DEVELOPMENT;
  }
  if (baseUrl && baseUrl.indexOf('sit.') !== -1) {
    return TRP_ENVIRONMENTS.DEVELOPMENT;
  }
  if (baseUrl && baseUrl.indexOf('stage.') !== -1) {
    return TRP_ENVIRONMENTS.STAGING;
  }
  return TRP_ENVIRONMENTS.PRODUCTION;
};

export const deriveOnpremiseEnvironment = (baseUrl) => {
  if (
    (baseUrl && baseUrl.indexOf('localhost:') !== -1) ||
    (baseUrl && baseUrl.indexOf('127.0.0.1:') !== -1)
  ) {
    return 'dev';
  }
  if (baseUrl && baseUrl.indexOf('dev') !== -1) {
    return 'dev';
  }
  if (baseUrl && baseUrl.indexOf('sit') !== -1) {
    return 'dev';
  }
  if (baseUrl && baseUrl.indexOf('stage') !== -1) {
    return 'qual';
  }
  return '';
};

export const isInternalContext = (baseUrl) => {
  return baseUrl && baseUrl.indexOf('.awstrp.net') !== -1;
};

const getF5BasePath = () => {
  return `https://www3${deriveOnpremiseEnvironment(
    getBaseUrl()
  )}.troweprice.com`;
};

export const getDerivedApigeeBasePath = () => {
  return getENV() === NODE_ENVIRONMENTS.LOCAL &&
    // eslint-disable-next-line no-undef
    process.env.REACT_APP_MOCK === 'true'
    ? getBaseUrl()
    : isInternalContext(getBaseUrl())
    ? `https://api${getApigeeEnvironmentPrefix(
        deriveEnvironment(getBaseUrl())
      )}.awstrp.net`
    : `https://api${getApigeeEnvironmentPrefix(
        deriveEnvironment(getBaseUrl())
      )}.troweprice.com`;
};

// TODO : I think this might be better served to be gotten from config in the future - built the means window.CONFIG
export const GLOBALS = {
  isSandbox: isSandbox(),
  AAM_TRP_BASE_APIGEE_URL: getDerivedApigeeBasePath(),
  AAM_TRP_TOKEN_EXCHANGE_URL: `https://api${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl())
  )}${
    isInternalContext(getBaseUrl()) ? '.awstrp.net' : '.troweprice.com'
  }/token-exchange-service/service/token`,
  AAM_TRP_FPS_BASE_APIGEE_URL: getDerivedApigeeBasePath(),
  AAM_TRP_CIAM_URL: `https://api${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl())
  )}.awstrp.net`,
  AAM_UI_EXTERNAL_BASE_URL: `https://www${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl()),
    false,
    true
  )}.troweprice.com`,
  AAM_UI_INTERNAL_BASE_URL: `https://www${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl()),
    false,
    true
  )}.awstrp.net`,
  AAM_APP_UI_INTERNAL_BASE_URL: `https://www${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl()),
    true,
    true,
    false
  )}.awstrp.net`,
  AAM_UI_NET_X_MESSAGE_URL:
    getENV() === TRP_ENVIRONMENTS.PRODUCTION
      ? 'https://troweprice.netxinvestor.com/c/portal/logout'
      : 'https://xat-troweprice-netxinvestor.bnymellon.com/web/troweprice/sso-logout?message=logout&errorCode=null',
  AAM_UI_NET_X_LOGOUT_URL:
    getENV() === TRP_ENVIRONMENTS.PRODUCTION
      ? 'https://troweprice.netxinvestor.com/web/troweprice/sso-logout?message=logout&errorCode=null'
      : 'https://xat-troweprice-netxinvestor.bnymellon.com/web/troweprice/sso-logout?message=logout&errorCode=null',
  AAM_UI_TRP_APP_CONTEXT: '/usis/my-accounts',
  AAM_UI_TRP_CLX_CONTEXT: '/usis/login',
  AAM_UI_TRP_AWS_ENVIRONMENT: `${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl()),
    false
  )}`,
  AAM_UI_TRP_BASE_URL: getF5BasePath(),
  AAM_UI_VAULT_BASE_URL: `https://vault${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl())
  )}.troweprice.io:8200`,
  AAM_BFF_BASE_URL: `${getDerivedApigeeBasePath()}/account-access-service/v4`,
  AAM_UI_FACTSET_BASE_URL: 'https://trp.factsetdigitalsolutions.com/',
  AAM_UI_MESSAGE_SERVICE_BASE_PATH: `${getDerivedApigeeBasePath()}/accountaccess-msg-svc`,
  AAM_UI_BROKERAGE_BASE_URL:
    getENV() === TRP_ENVIRONMENTS.PRODUCTION
      ? 'https://troweprice.netxinvestor.com'
      : 'https://xat-troweprice-netxinvestor.bnymellon.com',
  SESSION_TIMEOUT_MINUTES: 24,
  DISPLAY_TIMEOUT_WARNING_MINUTES: 2,
  AAM_INTERNAL_BASE_URL: `https://www${getEnvironmentPrefix(
    deriveEnvironment(getBaseUrl()),
    true,
    false
  )}.awstrp.net`,
  AAM_UI_PERSHING_REST:
    getENV() === TRP_ENVIRONMENTS.PRODUCTION
      ? 'https://troweprice.netxinvestor.com'
      : 'https://xat-troweprice-netxinvestor.bnymellon.com',
  AAM_UI_ACCOUNT_URL: '/account-access-service/v4'
};

export const getStaticApiKey = () => {
  const env = getENV();
  if (env === 'DEV') {
    return 'wpEs0rkBQHxhK3ouVG4yNrInFREVgpPX';
  }
  if (env === 'STAGE') {
    return 'Qck6yrYik36p3JM2W12I3Fp41OsCxZHG';
  }
  return 'K0Ax4NrCQOL9xZduniaLKVlQGhB74BHm';
};

export const navTypes = {
  CORE: 'CORE',
  SECURE: 'SECURE'
};

export default {
  FEATURES,
  GLOBALS,
  deriveEnvironment,
  getDerivedApigeeBasePath,
  getBaseUrl,
  getFullUrl,
  getRelativePath,
  getUrlParts,
  getENV,
  getEnvironmentPrefix,
  isInternalContext,
  NODE_ENVIRONMENTS,
  TRP_ENVIRONMENTS
};
